export default {
  getPopupPersonality: state => state.alreadySeePopupPersonality,
  getPreviousLanguage: state => state.previousLanguage
}
